import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme)=>({
    intro:{
        display:'flex',
        color:'white',
        padding:'20px auto',
        margin:'0 auto'
    },
    grid: {
        display: 'flex',
        alignItem:'center',

      },
    items:{
        marginTop:'20px',
        marginBottom:'8.4%',

    },
    imageContainer:{

        
    },
    image:{
        width:'50%',
        top:'10%',
        position:'relative',
        left:'15%',
        margin:'10%',
        borderRadius:'5%',
        '&:hover':{
            transform: 'translateY(-10px)',
            boxShadow: '1em 1em 1em -0.4em black'
          },
        transition:'all 0.3s'
    },
    // highlight:{
    //     '&:hover':{
    //         transform: 'translateY(-10px)',
    //         fontSize:'1.1em',
    //         color:'#39FF14',
    //         cursor:'pointer',
    //         textShadow:'none'
    //       }, 
    //       color:'white',
    //     textShadow:`
    //     -2px -2px 0 #000,
    //     2px -2px 0 #000,
    //     -2px 2px 0 #000,
    //     2px 2px 0 #000` ,
 
    //     transition:'all 0.3s'
    // },
    about:{
        marginTop:'10%',
        backgroundColor:'white',
        padding:'0%',
        borderRadius:'10px',
        heitht:'100%',
        textAlign:'left'
    },
    about1:{
        textAlign:'left',
        fontSize:'25px',
        marginTop:'40px',
        border:'3px solid black',
        borderRadius:'5px',
        padding:'10px'
    },
    icons:{
        backgroundColor:'white'
    },
    main:{
        padding:'20px',
        minHeight:'85vh'
    }
}));
export default useStyles;